import { EnvironmentStage } from "@amzn/aws-marketing-experience-builder-template-types";
import { TypeaheadItem as ExternalTypeaheadItem } from "@amzn/rigel-pattern-global-nav";

export { EnvironmentStage };
export type TypeaheadItem = ExternalTypeaheadItem;

export interface DirectoryItem {
  id: string;
  directoryId: string;
  name: string;
  locale: string;
  dateCreated: string;
  dateUpdated: string;
  additionalFields?: Record<string, string | undefined>;
}

export type DirectoryFieldTypes = {
  pricingUrl: string;
  docsUrl: string;
  rank: string;
  title: string;
  category: string;
  primaryUrl: string;
  desc: string;
  calculatorUrl: string;
};

export type DirectoryEndkey = {
  "Id-Locale": string;
  "DirectoryId-Locale": string;
  "Target-Status-SortOrderValue": string;
  Target: string;
};

export type DirectoryMetadata = {
  count: number;
  totalHits: number;
  endKey: DirectoryEndkey;
  endMarker: string;
};

export type DirectoryResponse = {
  items: DirectoryItem[];
  metadata: DirectoryMetadata;
  fieldTypes: DirectoryFieldTypes;
};

export type DirectoryTag = {
  id: string;
  locale: string;
  dateCreated: string;
  dateUpdated: string;
  name: string;
  description: string;
  tagNamespaceId: string;
};

type DirectoriesSearchItem = {
  item: DirectoryItem;
  tags: DirectoryTag[];
};

export type DirectoriesSearchResponse = {
  items: DirectoriesSearchItem[];
  fieldTypes: Record<
    string,
    "Text" | "LongText" | "URL" | "Number" | "Boolean"
  >;
  metadata: DirectoryMetadata;
};

const LocaleValues = [
  "en-US",
  "ar-SA",
  "de-DE",
  "es-ES",
  "fr-FR",
  "ja-JP",
  "id-ID",
  "it-IT",
  "ko-KR",
  "pt-BR",
  "ru-RU",
  "th-TH",
  "tr-TR",
  "vi-VN",
  "zh-CN",
  "zh-TW",
] as const;

export type Locale = (typeof LocaleValues)[number];
export const LocalValuesLowercase = LocaleValues.map((v) => v.toLowerCase());
export const DefaultLocale: Locale = "en-US" satisfies Locale;
